(function () {
  'use strict';

  function isImageElement(target) {
    return target instanceof Element && !!target.closest('img, picture');
  }

  function hasBackgroundImage(target) {
    if (!(target instanceof Element)) return false;
    return window.getComputedStyle(target).backgroundImage !== 'none';
  }

  document.addEventListener('contextmenu', function (event) {
    if (isImageElement(event.target) || hasBackgroundImage(event.target)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (isImageElement(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('copy', function (event) {
    if (isImageElement(event.target) || document.activeElement instanceof HTMLImageElement) {
      event.preventDefault();
      return;
    }

    var selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    for (var index = 0; index < selection.rangeCount; index += 1) {
      var fragment = selection.getRangeAt(index).cloneContents();
      if (fragment.querySelector && fragment.querySelector('img, picture')) {
        event.preventDefault();
        return;
      }
    }
  }, true);
})();
